// Localizes a Bible verse reference's BOOK NAME per language.
// The verse text is left untouched (only the reference "Book chapter:verse").
// Stored references are in French (Louis Segond); we translate the book name.

const norm = (s) =>
  String(s || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();

// key = normalized French book name → { en, es, pt }
const RAW = [
  ["Genèse", "Genesis", "Génesis", "Gênesis"],
  ["Exode", "Exodus", "Éxodo", "Êxodo"],
  ["Lévitique", "Leviticus", "Levítico", "Levítico"],
  ["Nombres", "Numbers", "Números", "Números"],
  ["Deutéronome", "Deuteronomy", "Deuteronomio", "Deuteronômio"],
  ["Josué", "Joshua", "Josué", "Josué"],
  ["Juges", "Judges", "Jueces", "Juízes"],
  ["Ruth", "Ruth", "Rut", "Rute"],
  ["1 Samuel", "1 Samuel", "1 Samuel", "1 Samuel"],
  ["2 Samuel", "2 Samuel", "2 Samuel", "2 Samuel"],
  ["1 Rois", "1 Kings", "1 Reyes", "1 Reis"],
  ["2 Rois", "2 Kings", "2 Reyes", "2 Reis"],
  ["1 Chroniques", "1 Chronicles", "1 Crónicas", "1 Crônicas"],
  ["2 Chroniques", "2 Chronicles", "2 Crónicas", "2 Crônicas"],
  ["Esdras", "Ezra", "Esdras", "Esdras"],
  ["Néhémie", "Nehemiah", "Nehemías", "Neemias"],
  ["Esther", "Esther", "Ester", "Ester"],
  ["Job", "Job", "Job", "Jó"],
  ["Psaumes", "Psalms", "Salmos", "Salmos"],
  ["Psaume", "Psalm", "Salmo", "Salmo"],
  ["Proverbes", "Proverbs", "Proverbios", "Provérbios"],
  ["Ecclésiaste", "Ecclesiastes", "Eclesiastés", "Eclesiastes"],
  ["Cantique des cantiques", "Song of Songs", "Cantares", "Cânticos"],
  ["Ésaïe", "Isaiah", "Isaías", "Isaías"],
  ["Jérémie", "Jeremiah", "Jeremías", "Jeremias"],
  ["Lamentations", "Lamentations", "Lamentaciones", "Lamentações"],
  ["Ézéchiel", "Ezekiel", "Ezequiel", "Ezequiel"],
  ["Daniel", "Daniel", "Daniel", "Daniel"],
  ["Osée", "Hosea", "Oseas", "Oseias"],
  ["Joël", "Joel", "Joel", "Joel"],
  ["Amos", "Amos", "Amós", "Amós"],
  ["Abdias", "Obadiah", "Abdías", "Obadias"],
  ["Jonas", "Jonah", "Jonás", "Jonas"],
  ["Michée", "Micah", "Miqueas", "Miquéias"],
  ["Nahum", "Nahum", "Nahúm", "Naum"],
  ["Habacuc", "Habakkuk", "Habacuc", "Habacuque"],
  ["Sophonie", "Zephaniah", "Sofonías", "Sofonias"],
  ["Aggée", "Haggai", "Hageo", "Ageu"],
  ["Zacharie", "Zechariah", "Zacarías", "Zacarias"],
  ["Malachie", "Malachi", "Malaquías", "Malaquias"],
  ["Matthieu", "Matthew", "Mateo", "Mateus"],
  ["Marc", "Mark", "Marcos", "Marcos"],
  ["Luc", "Luke", "Lucas", "Lucas"],
  ["Jean", "John", "Juan", "João"],
  ["Actes", "Acts", "Hechos", "Atos"],
  ["Romains", "Romans", "Romanos", "Romanos"],
  ["1 Corinthiens", "1 Corinthians", "1 Corintios", "1 Coríntios"],
  ["2 Corinthiens", "2 Corinthians", "2 Corintios", "2 Coríntios"],
  ["Galates", "Galatians", "Gálatas", "Gálatas"],
  ["Éphésiens", "Ephesians", "Efesios", "Efésios"],
  ["Philippiens", "Philippians", "Filipenses", "Filipenses"],
  ["Colossiens", "Colossians", "Colosenses", "Colossenses"],
  ["1 Thessaloniciens", "1 Thessalonians", "1 Tesalonicenses", "1 Tessalonicenses"],
  ["2 Thessaloniciens", "2 Thessalonians", "2 Tesalonicenses", "2 Tessalonicenses"],
  ["1 Timothée", "1 Timothy", "1 Timoteo", "1 Timóteo"],
  ["2 Timothée", "2 Timothy", "2 Timoteo", "2 Timóteo"],
  ["Tite", "Titus", "Tito", "Tito"],
  ["Philémon", "Philemon", "Filemón", "Filemom"],
  ["Hébreux", "Hebrews", "Hebreos", "Hebreus"],
  ["Jacques", "James", "Santiago", "Tiago"],
  ["1 Pierre", "1 Peter", "1 Pedro", "1 Pedro"],
  ["2 Pierre", "2 Peter", "2 Pedro", "2 Pedro"],
  ["1 Jean", "1 John", "1 Juan", "1 João"],
  ["2 Jean", "2 John", "2 Juan", "2 João"],
  ["3 Jean", "3 John", "3 Juan", "3 João"],
  ["Jude", "Jude", "Judas", "Judas"],
  ["Apocalypse", "Revelation", "Apocalipsis", "Apocalipse"],
];

const BOOKS = {};
for (const [fr, en, es, pt] of RAW) BOOKS[norm(fr)] = { fr, en, es, pt };

// "Lamentations 3:22-23" + "es" → "Lamentaciones 3:22-23"
export function localizeReference(reference, lang) {
  const ref = String(reference || "").trim();
  if (!ref || !lang || lang === "fr") return ref;
  const m = ref.match(/^(.+?)\s+(\d+[:.]\d+.*)$/);
  if (!m) return ref;
  const entry = BOOKS[norm(m[1])];
  if (!entry) return ref;
  return `${entry[lang] || m[1].trim()} ${m[2].trim()}`;
}
